const fullNameShorten = (fullName, length) => {
  return fullName
    .split(' ')
    .slice(0, length)
    .join(' ');
};

export default fullNameShorten;
